import React from "react";

import { useDialog } from "../../components/ui/use-dialog";

import { ErrorDialog } from "../../pages/_shared/_dialog/error";
import { TipsDialog } from "../../pages/_shared/_dialog/tips";

import { TError } from "../../types/error";

interface Errors {
  error: (error: any) => void;
}

const ErrorContext = React.createContext<Errors | null>(null);

export function DialogProvider({ children }: { children: React.ReactNode }) {
  const [error, setError] = React.useState<TError>(null);
  const dialog = useDialog();

  const errors: Errors = {
    error: setError,
  };

  React.useEffect(() => {
    if (error) dialog.open();
  }, [error, dialog]);

  return (
    <ErrorContext.Provider value={errors}>
      {children}
      {dialog.isOpen ? (
        <ErrorDialog
          open={dialog.isOpen}
          onOpenChange={dialog.close}
          error={error}
          setError={setError}
        />
      ) : (
        <TipsDialog />
      )}
    </ErrorContext.Provider>
  );
}

export function useError() {
  const context = React.useContext(ErrorContext);
  if (!context) {
    throw new Error("useError must be used within an DialogProvider");
  }
  return context;
}
